<template><section><h1>popper 浮窗</h1>
<h2 id="dai-ma-yan-shi"><a class="header-anchor" href="#dai-ma-yan-shi">¶</a> 代码演示</h2>

<h3 id="ji-chu-ying-yong"><a class="header-anchor" href="#ji-chu-ying-yong">¶</a> 基础应用</h3>

      <demo-block class="demo-box" :jsfiddle="{&quot;html&quot;:&quot;&lt;com-popper&gt;\n    &lt;template v-slot:reference&gt;悬浮显示浮窗&lt;/template&gt;\n    这是浮窗的内容\n&lt;/com-popper&gt;\n&quot;,&quot;script&quot;:null,&quot;style&quot;:null}">
        <div class="source" slot="source"><com-popper>
    <template v-slot:reference>悬浮显示浮窗</template>
    这是浮窗的内容
</com-popper>
</div>
        
        <div class="hljs highlight" slot="highlight">
    <pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">com-popper</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">template</span> <span class="hljs-attr">v-slot:reference</span>&gt;</span>悬浮显示浮窗<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
    这是浮窗的内容
<span class="hljs-tag">&lt;/<span class="hljs-name">com-popper</span>&gt;</span>
</code></pre>
</div></demo-block>
<h3 id="xuan-ze-chu-fapopper-fang-shi"><a class="header-anchor" href="#xuan-ze-chu-fapopper-fang-shi">¶</a> 选择触发popper方式</h3>
<p>设置<code v-pre>arrow</code>属性控制是否显示箭头， 设置<code v-pre>canEnter</code>可控制鼠标能否进入浮窗内容区，仅<code v-pre>trigger: hover</code>时有效。</p>


      <demo-block class="demo-box" :jsfiddle="{&quot;html&quot;:&quot;&lt;com-popper trigger=\&quot;hover\&quot; :can-enter=\&quot;true\&quot;&gt;\n    &lt;template v-slot:reference&gt;悬浮显示浮窗&lt;/template&gt;\n    &lt;p&gt;这是浮窗的内容&lt;/p&gt;\n&lt;/com-popper&gt;\n\n&lt;com-popper trigger=\&quot;click\&quot; :arrow=\&quot;true\&quot;&gt;\n    &lt;template v-slot:reference&gt;点击显示浮窗&lt;/template&gt;\n    这是浮窗的内容\n&lt;/com-popper&gt;\n&quot;,&quot;script&quot;:null,&quot;style&quot;:null}">
        <div class="source" slot="source"><com-popper trigger="hover" :can-enter="true">
    <template v-slot:reference>悬浮显示浮窗</template>
    <p>这是浮窗的内容</p>
</com-popper>

<com-popper trigger="click" :arrow="true">
    <template v-slot:reference>点击显示浮窗</template>
    这是浮窗的内容
</com-popper>
</div>
        
        <div class="hljs highlight" slot="highlight">
    <pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">com-popper</span> <span class="hljs-attr">trigger</span>=<span class="hljs-string">"hover"</span> <span class="hljs-attr">:can-enter</span>=<span class="hljs-string">"true"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">template</span> <span class="hljs-attr">v-slot:reference</span>&gt;</span>悬浮显示浮窗<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>这是浮窗的内容<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">com-popper</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">com-popper</span> <span class="hljs-attr">trigger</span>=<span class="hljs-string">"click"</span> <span class="hljs-attr">:arrow</span>=<span class="hljs-string">"true"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">template</span> <span class="hljs-attr">v-slot:reference</span>&gt;</span>点击显示浮窗<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
    这是浮窗的内容
<span class="hljs-tag">&lt;/<span class="hljs-name">com-popper</span>&gt;</span>
</code></pre>
</div></demo-block>
<h3 id="dai-ma-kong-zhi-fu-chuang-zhuang-tai"><a class="header-anchor" href="#dai-ma-kong-zhi-fu-chuang-zhuang-tai">¶</a> 代码控制浮窗状态</h3>
<p>通过传递<code v-pre>value</code>值，能初始化或后续改变浮窗的显示/隐藏状态。 该值会跟trigger操作同步状态。</p>

      <demo-block class="demo-box" :jsfiddle="{&quot;html&quot;:&quot;&lt;com-popper v-model=\&quot;value1\&quot; trigger=\&quot;click\&quot;&gt;\n    &lt;template v-slot:reference&gt;点击显示浮窗&lt;/template&gt;\n    这是浮窗的内容\n&lt;/com-popper&gt;\n&quot;,&quot;script&quot;:&quot;\n    export default {\n        data () {\n            return {\n                value1: true\n            };\n        }\n    }\n&quot;,&quot;style&quot;:null}">
        <div class="source" slot="source"><com-popper v-model="value1" trigger="click">
    <template v-slot:reference>点击显示浮窗</template>
    这是浮窗的内容
</com-popper>
</div>
        
        <div class="hljs highlight" slot="highlight">
    <pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">com-popper</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"value1"</span> <span class="hljs-attr">trigger</span>=<span class="hljs-string">"click"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">template</span> <span class="hljs-attr">v-slot:reference</span>&gt;</span>点击显示浮窗<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
    这是浮窗的内容
<span class="hljs-tag">&lt;/<span class="hljs-name">com-popper</span>&gt;</span>
</code></pre>
<pre v-pre><code v-pre class="language-js">&lt;script&gt;
    <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
        data () {
            <span class="hljs-keyword">return</span> {
                <span class="hljs-attr">value1</span>: <span class="hljs-literal">true</span>
            };
        }
    }
&lt;<span class="hljs-regexp">/script&gt;
</span></code></pre>
</div></demo-block>
<h3 id="tong-guochange-huo-qupopper-zhuang-tai"><a class="header-anchor" href="#tong-guochange-huo-qupopper-zhuang-tai">¶</a> 通过change获取popper状态</h3>

      <demo-block class="demo-box" :jsfiddle="{&quot;html&quot;:&quot;&lt;com-popper trigger=\&quot;hover\&quot; @change=\&quot;handleChange\&quot;&gt;\n    &lt;template v-slot:reference&gt;悬浮显示浮窗&lt;/template&gt;\n    这是浮窗的内容\n&lt;/com-popper&gt;\n\n&lt;span ref=\&quot;demo3\&quot; style=\&quot;margin-left: 100px;\&quot;&gt;&lt;/span&gt;\n&quot;,&quot;script&quot;:&quot;\n    export default {\n        methods: {\n            handleChange (value) {\n                this.$refs.demo3.innerText = value;\n            }\n        }\n    };\n&quot;,&quot;style&quot;:null}">
        <div class="source" slot="source"><com-popper trigger="hover" @change="handleChange">
    <template v-slot:reference>悬浮显示浮窗</template>
    这是浮窗的内容
</com-popper>

<span ref="demo3" style="margin-left: 100px;"></span>
</div>
        
        <div class="hljs highlight" slot="highlight">
    <pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">com-popper</span> <span class="hljs-attr">trigger</span>=<span class="hljs-string">"hover"</span> <span class="hljs-attr">@change</span>=<span class="hljs-string">"handleChange"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">template</span> <span class="hljs-attr">v-slot:reference</span>&gt;</span>悬浮显示浮窗<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
    这是浮窗的内容
<span class="hljs-tag">&lt;/<span class="hljs-name">com-popper</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">span</span> <span class="hljs-attr">ref</span>=<span class="hljs-string">"demo3"</span> <span class="hljs-attr">style</span>=<span class="hljs-string">"margin-left: 100px;"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span>
</code></pre>
<pre v-pre><code v-pre class="language-js">&lt;script&gt;
    <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
        <span class="hljs-attr">methods</span>: {
            handleChange (value) {
                <span class="hljs-keyword">this</span>.$refs.demo3.innerText = value;
            }
        }
    };
&lt;<span class="hljs-regexp">/script&gt;
</span></code></pre>
</div></demo-block>
<h3 id="bu-tong-fang-xiang"><a class="header-anchor" href="#bu-tong-fang-xiang">¶</a> 不同方向</h3>

      <demo-block class="demo-box" :jsfiddle="{&quot;html&quot;:&quot;&lt;com-popper placement=\&quot;top\&quot;&gt;\n    &lt;template v-slot:reference&gt;&lt;button&gt;向上&lt;/button&gt;&lt;/template&gt;\n    这是浮窗的内容\n&lt;/com-popper&gt;\n\n&lt;com-popper placement=\&quot;bottom\&quot;&gt;\n    &lt;template v-slot:reference&gt;&lt;button&gt;向下&lt;/button&gt;&lt;/template&gt;\n    这是浮窗的内容\n&lt;/com-popper&gt;\n\n&lt;com-popper placement=\&quot;left\&quot;&gt;\n    &lt;template v-slot:reference&gt;&lt;button&gt;向左&lt;/button&gt;&lt;/template&gt;\n    这是浮窗的内容\n&lt;/com-popper&gt;\n\n&lt;com-popper placement=\&quot;right\&quot;&gt;\n    &lt;template v-slot:reference&gt;&lt;button&gt;向右&lt;/button&gt;&lt;/template&gt;\n    这是浮窗的内容\n&lt;/com-popper&gt;\n\n&lt;com-popper placement=\&quot;right-end\&quot;&gt;\n    &lt;template v-slot:reference&gt;&lt;button&gt;right-end&lt;/button&gt;&lt;/template&gt;\n    这是浮窗的内容\n&lt;/com-popper&gt;\n\n&lt;com-popper placement=\&quot;top-start\&quot;&gt;\n    &lt;template v-slot:reference&gt;&lt;button&gt;top-start&lt;/button&gt;&lt;/template&gt;\n    这是浮窗的内容\n&lt;/com-popper&gt;\n\n&lt;com-popper placement=\&quot;bottom-end\&quot;&gt;\n    &lt;template v-slot:reference&gt;&lt;button&gt;bottom-end&lt;/button&gt;&lt;/template&gt;\n    这是浮窗的内容\n&lt;/com-popper&gt;\n\n&lt;com-popper placement=\&quot;left-start\&quot;&gt;\n    &lt;template v-slot:reference&gt;&lt;button&gt;left-start&lt;/button&gt;&lt;/template&gt;\n    这是浮窗的内容\n&lt;/com-popper&gt;\n&quot;,&quot;script&quot;:null,&quot;style&quot;:null}">
        <div class="source" slot="source"><com-popper placement="top">
    <template v-slot:reference><button>向上</button></template>
    这是浮窗的内容
</com-popper>

<com-popper placement="bottom">
    <template v-slot:reference><button>向下</button></template>
    这是浮窗的内容
</com-popper>

<com-popper placement="left">
    <template v-slot:reference><button>向左</button></template>
    这是浮窗的内容
</com-popper>

<com-popper placement="right">
    <template v-slot:reference><button>向右</button></template>
    这是浮窗的内容
</com-popper>

<com-popper placement="right-end">
    <template v-slot:reference><button>right-end</button></template>
    这是浮窗的内容
</com-popper>

<com-popper placement="top-start">
    <template v-slot:reference><button>top-start</button></template>
    这是浮窗的内容
</com-popper>

<com-popper placement="bottom-end">
    <template v-slot:reference><button>bottom-end</button></template>
    这是浮窗的内容
</com-popper>

<com-popper placement="left-start">
    <template v-slot:reference><button>left-start</button></template>
    这是浮窗的内容
</com-popper>
</div>
        
        <div class="hljs highlight" slot="highlight">
    <pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">com-popper</span> <span class="hljs-attr">placement</span>=<span class="hljs-string">"top"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">template</span> <span class="hljs-attr">v-slot:reference</span>&gt;</span><span class="hljs-tag">&lt;<span class="hljs-name">button</span>&gt;</span>向上<span class="hljs-tag">&lt;/<span class="hljs-name">button</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
    这是浮窗的内容
<span class="hljs-tag">&lt;/<span class="hljs-name">com-popper</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">com-popper</span> <span class="hljs-attr">placement</span>=<span class="hljs-string">"bottom"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">template</span> <span class="hljs-attr">v-slot:reference</span>&gt;</span><span class="hljs-tag">&lt;<span class="hljs-name">button</span>&gt;</span>向下<span class="hljs-tag">&lt;/<span class="hljs-name">button</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
    这是浮窗的内容
<span class="hljs-tag">&lt;/<span class="hljs-name">com-popper</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">com-popper</span> <span class="hljs-attr">placement</span>=<span class="hljs-string">"left"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">template</span> <span class="hljs-attr">v-slot:reference</span>&gt;</span><span class="hljs-tag">&lt;<span class="hljs-name">button</span>&gt;</span>向左<span class="hljs-tag">&lt;/<span class="hljs-name">button</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
    这是浮窗的内容
<span class="hljs-tag">&lt;/<span class="hljs-name">com-popper</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">com-popper</span> <span class="hljs-attr">placement</span>=<span class="hljs-string">"right"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">template</span> <span class="hljs-attr">v-slot:reference</span>&gt;</span><span class="hljs-tag">&lt;<span class="hljs-name">button</span>&gt;</span>向右<span class="hljs-tag">&lt;/<span class="hljs-name">button</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
    这是浮窗的内容
<span class="hljs-tag">&lt;/<span class="hljs-name">com-popper</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">com-popper</span> <span class="hljs-attr">placement</span>=<span class="hljs-string">"right-end"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">template</span> <span class="hljs-attr">v-slot:reference</span>&gt;</span><span class="hljs-tag">&lt;<span class="hljs-name">button</span>&gt;</span>right-end<span class="hljs-tag">&lt;/<span class="hljs-name">button</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
    这是浮窗的内容
<span class="hljs-tag">&lt;/<span class="hljs-name">com-popper</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">com-popper</span> <span class="hljs-attr">placement</span>=<span class="hljs-string">"top-start"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">template</span> <span class="hljs-attr">v-slot:reference</span>&gt;</span><span class="hljs-tag">&lt;<span class="hljs-name">button</span>&gt;</span>top-start<span class="hljs-tag">&lt;/<span class="hljs-name">button</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
    这是浮窗的内容
<span class="hljs-tag">&lt;/<span class="hljs-name">com-popper</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">com-popper</span> <span class="hljs-attr">placement</span>=<span class="hljs-string">"bottom-end"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">template</span> <span class="hljs-attr">v-slot:reference</span>&gt;</span><span class="hljs-tag">&lt;<span class="hljs-name">button</span>&gt;</span>bottom-end<span class="hljs-tag">&lt;/<span class="hljs-name">button</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
    这是浮窗的内容
<span class="hljs-tag">&lt;/<span class="hljs-name">com-popper</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">com-popper</span> <span class="hljs-attr">placement</span>=<span class="hljs-string">"left-start"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">template</span> <span class="hljs-attr">v-slot:reference</span>&gt;</span><span class="hljs-tag">&lt;<span class="hljs-name">button</span>&gt;</span>left-start<span class="hljs-tag">&lt;/<span class="hljs-name">button</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
    这是浮窗的内容
<span class="hljs-tag">&lt;/<span class="hljs-name">com-popper</span>&gt;</span>
</code></pre>
</div></demo-block>
<h3 id="props"><a class="header-anchor" href="#props">¶</a> Props</h3>
<table class="table"><thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
<th>是否必填</th>
</tr>
</thead>
<tbody>
<tr>
<td>value</td>
<td>浮窗的状态，true代表打开状态，false代表收起状态，可用v-model</td>
<td>Boolean</td>
<td>true/false</td>
<td>—</td>
<td>no</td>
</tr>
<tr>
<td>placement</td>
<td>浮窗的位置</td>
<td>String</td>
<td>auto, auto-start, auto-end, top, top-start, top-end, bottom, bottom-start, bottom-end, right, right-start, right-end, left,  left-start, left-end</td>
<td>bottom</td>
<td>no</td>
</tr>
<tr>
<td>arrow</td>
<td>是否显示箭头</td>
<td>Boolean</td>
<td>true/false</td>
<td>false</td>
<td>no</td>
</tr>
<tr>
<td>trigger</td>
<td>触发浮窗的事件</td>
<td>String</td>
<td>hover/click</td>
<td>hover</td>
<td>no</td>
</tr>
<tr>
<td>isHiddenOut</td>
<td>是否点击空白处消失</td>
<td>Boolean</td>
<td>true/false</td>
<td>true</td>
<td>no</td>
</tr>
<tr>
<td>canEnter</td>
<td>trigger：hover时鼠标能否进入popper内容区</td>
<td>Boolean</td>
<td>true/false</td>
<td>false</td>
<td>no</td>
</tr>
<tr>
<td>canToggle</td>
<td>trigger：click，鼠标点击触发器时，能否实现开关切换效果，即打开了的popper，再点击一次触发器，是否会收起popper</td>
<td>Boolean</td>
<td>true/false</td>
<td>true</td>
<td>no</td>
</tr>
</tbody>
</table>
<h3 id="events"><a class="header-anchor" href="#events">¶</a> events</h3>
<table class="table"><thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>change</td>
<td>改变复选框值触发</td>
<td>新值</td>
</tr>
</tbody>
</table>
</section></template>
<style>
    .com-popper + .com-popper {
        margin-left: 16px;
    }
</style>
<script>
    export default {
        data () {
            return {
                value1: true
            };
        },
        methods: {
            handleChange (value) {
                this.$refs.demo3.innerText = value;
            }
        }
    }
</script>